import React, { useEffect, useState } from "react";
import moment from "moment";
import { IdleTimeOutModal } from "./IdleModal";

const IdleTimeOutHandler = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [isLogout, setLogout] = useState(false);
  let timer = undefined;
  let newRoute = process.env.REACT_APP_OMMITTED_PAGES.split(",");

  const events = ["click", "load", "keydown"];
  const eventHandler = (eventType) => {
    if (!isLogout && !newRoute.includes(window.location.href)) {
      sessionStorage.setItem("lastInteractionTime", moment());
      if (timer) {
        props.onActive();
        startTimer(); 
      }
    } else {
      setShowModal(false);
    }
  };

  useEffect(() => {
    addEvents();

    return () => {
      removeEvents();
      clearTimeout(timer);
    };
  }, []);

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(
      () => {
        // let newRoute = process.env.REACT_APP_OMMITTED_PAGES

        if (newRoute.includes(window.location.href)) {
          clearTimeout(timer);
          sessionStorage.clear();
          return;
        }
        const lastInteractionTime = sessionStorage.getItem(
          "lastInteractionTime"
        );
        const diff = moment.duration(
          moment().diff(moment(lastInteractionTime))
        );
        let timeOutInterval = props.timeOutInterval
          ? props.timeOutInterval
          : 300000;
        if (isLogout) {
          clearTimeout(timer);
          sessionStorage.clear();
        } else {
          if (diff._milliseconds < timeOutInterval) {
            startTimer();
            props.onActive();
          } else {
            props.onIdle();

            if (!newRoute.includes(window.location.pathname))
              window.location.href = "/";
            sessionStorage.clear();
            localStorage.clear();
            setShowModal(false);
          }
        }
      },
      props.timeOutInterval ? props.timeOutInterval : 300000
    );
  };
  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });

    startTimer();
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  const handleContinueSession = () => {
    setShowModal(false);
    setLogout(false);
  };
  const handleLogout = () => {
    removeEvents();
    clearTimeout(timer);
    setLogout(true);
    sessionStorage.clear();
    localStorage.clear();
    props.onLogout();
    setShowModal(false);
  };

  useEffect(() => {
    const handlePopState = () => {
      if (!sessionStorage.getItem("lastInteractionTime")) {
        window.location.href = "/";
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div>
      <IdleTimeOutModal
        showModal={showModal}
        handleContinue={handleContinueSession}
        handleLogout={handleLogout}
      />
    </div>
  );
};

export default IdleTimeOutHandler;
